import { render, staticRenderFns } from "./PositionDetailCard.vue?vue&type=template&id=37a666b6"
import script from "./PositionDetailCard.vue?vue&type=script&lang=js"
export * from "./PositionDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports